<template>
  <div class="products">
    <div class="products-banner">
    <!-- <img class="products-banner" src="~@/static/projectImg/login/banner.svg" alt="Image" /> -->
      <img class="products-banner-img" src="~@/assets/productCenter/banner-right.png" alt="Image" />
      <img class="banner-text" src="~@/static/projectImg/login/banner-text.png" alt="Image" />
      <div class="banner-txt-wrap">
        <!-- <div class="banner-title">Product Center</div>
        <div class="info-text">Provide you with the best product experience</div> -->
      </div>
    </div>
    <div class="products-wrap">
      <div class="products-wrap-title"> {{ $t('productCenter.product') }}</div>
      <div style="display: flex; gap: 20px; flex-wrap: wrap;">
        <div class="products-item" v-for="(item, index) in products" :key="index">
          <div class="products-item-left">
            <div class="products-item-left_title">
              <span :class="'icon'+ index" class="products-item-left_title-icon"></span>
              <span class="title_name">{{ item.name }}</span>
              <span
                class="products-item-left_tip "
                v-if="item.status === 'ACTIVATED' && (['EXPORT_DRAWBACK_TRADE', 'EXPORT_DRAWBACK_PROD'].includes(item.productType))"
              >
                {{ $t('productCenter.freeTrial') }}
              </span>
                <div class="slanting-banner" :class="item.status" :style="{'font-size': $i18n.locale === 'en' ? '12px' : '10px'}">
                  {{ statusMap[item.status].text }}
                </div>
            </div>
            
            
            <lls-tooltip
              class="item"
              effect="dark"
              :content="item.describe"
              placement="top"
              popper-class="custom-tooltip"
            >
              <div class="products-item-left_des">
                {{ item.describe }}
              </div>
            </lls-tooltip>
          </div>
          <div class="products-item-left_btn">
            <lls-button
              plain
              v-if="'ACTIVATED' === item.status"
              type="primary"
              @click="handleUse(item)"
              style="background-color: none;"
            >
              {{ $t('productCenter.useNow') }} <i class="lls-icon-right"></i>
            </lls-button>
            <lls-button
              v-else-if="!['ACTIVATED'].includes(item.status) && ['ENDURANCE'].includes(item.enterpriseStatus)"
              type="primary"
              @click="handleGrant"
              :disabled="disabledGrant"
            >
              {{ $t('productCenter.activate') }} <i class="lls-icon-right"></i>
            </lls-button>
            <lls-button
              v-else-if="['INIT','REJECT','SUBMIT','BACK'].includes(item.enterpriseStatus)"
              type="primary"
              :disabled="['SUBMIT'].includes(item.enterpriseStatus)"
              @click="handleAuthentication(item)"
            >
              {{ $t('productCenter.verify') }}
              <i class="lls-icon-right"></i>
            </lls-button>
            <div
              class="subscribe-now-wrapper"
              v-if="
                ['EXPORT_DRAWBACK_TRADE', 'EXPORT_DRAWBACK_PROD'].includes(
                  item.productType
                )
              "
            >
              <div class="qrcode-wrapper" v-if="qrCodeVisible">
                <img
                  :src="qrCodeSrc"
                  alt=""
                  style="width: 100px;height: 100px;"
                />
                <div class="qrcode-tip">{{ $t('productCenter.scanCode') }}</div>
              </div>
              <lls-button
                type="primary"
                @click="qrCodeVisible = !qrCodeVisible"
              >
                {{ $t('productCenter.subscribeNow') }}  <i class="lls-icon-right"></i>
              </lls-button>
            </div>
          </div>
          <!-- <div class="products-item-right">
            <img :src="item.imgSrc" alt="" />
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'productCenter',
  components: {},
  inject: ['switchProductByMenuCode'],
  props: {},
  data() {
    return {
      statusMap: {
        NOT_APPROVED: {
          text: this.$t('productCenter.inactive'),
          tagType: 'warning',
        },
        UNDER_REVIEW: {
          text: this.$t('productCenter.underReview'),
          tagType: 'warning',
        },
        ACTIVATED: {
          text: this.$t('productCenter.active'),
          tagType: 'success',
        },
        FAILED: {
          text: this.$t('productCenter.failed'),
          tagType: 'danger',
        },
      },
      productsStatus: [],
      productsMap: {
        EXPORT_DRAWBACK_PROD: {
          enabled: true,
          name: this.$t('productCenter.exportDrawback'),
          describe: this.$t('productCenter.exportDrawbackDes'),
          status: '',
          msg: '',
          imgSrc: require('@/assets/productCenter/ExportDrawback.jpg'),
          kycRoutePath: '/exportDrawbackKyc',
          menuCode: 'MEUCN9100',
          enterpriseStatus:''
        },
        EXPORT_DRAWBACK_TRADE: {
          enabled: true,
          name: this.$t('productCenter.exportDrawback'),
          describe: this.$t('productCenter.exportDrawbackDes'),
          status: '',
          msg: '',
          imgSrc: require('@/assets/productCenter/ExportDrawback.jpg'),
          kycRoutePath: '/exportDrawbackKyc',
          menuCode: 'MEUCN9000',
          enterpriseStatus:''
        },
        ACCOUNT: {
          enabled: true,
          name: this.$t('productCenter.digitalPayment'),
          describe: this.$t('productCenter.digitalPaymentDes'),
          status: '',
          msg: '',
          imgSrc: require('@/assets/productCenter/DigitalPayment.jpg'),
          kycRoutePath: '/CommKycFile',
          menuCode: 'MEUC7001',
          enterpriseStatus:''
        },
        E_FINANCE: {
          enabled: true,
          name: this.$t('productCenter.digitalFinance'),
          describe: this.$t('productCenter.digitalFinanceDes'),
          status: '',
          msg: '',
          imgSrc: require('@/assets/productCenter/DigitalFinance.jpg'),
          kycRoutePath: '/CommKycFile',
          menuCode: 'MEUC8002',
          enterpriseStatus:''
        },
        MARKET: {
          enabled: true,
          name: this.$t('productCenter.marketplace'),
          describe: this.$t('productCenter.marketplaceDes'),
          status: '',
          msg: '',
          imgSrc: require('@/assets/productCenter/ExportDrawback.jpg'),
          kycRoutePath: '',
          menuCode: 'MEUC9001',
          enterpriseStatus:''
        },
        DTT: {
          enabled: true,
          name: this.$t('productCenter.DTT'),
          describe: this.$t('productCenter.DTTDes'),
          status: '',
          msg: '',
          imgSrc: require('@/assets/productCenter/ExportDrawback.jpg'),
          kycRoutePath: '',
          menuCode: 'DTT',
          enterpriseStatus:''
        },
      },
      qrCodeVisible: false,
      qrCodeSrc: location.origin + '/frontSource/export/wx_ftt.png',
    }
  },
  // 计算属性
  computed: {
    products() {
      return this.productsStatus.map(v => {
        const productStatus = JSON.parse(v.productStatus)
        const productType = JSON.parse(v.productType)
        const enterpriseStatus = JSON.parse(v.enterpriseStatus)
        return {
          ...this.productsMap[productType.dictParam],
          status: productStatus.dictParam,
          productType: productType.dictParam,
          msg: v.msg || '',
          enterpriseStatus: enterpriseStatus.dictParam
        }
      })
    },
    disabledGrant() {
      return this.products.some(v => v.status === 'UNDER_REVIEW')
    },
  },
  // 监听属性
  watch: {},
  // 生命周期 - 创建完成(访问当前this实例)
  created() {
    const hasSkip = sessionStorage.getItem('hasSkip')
    if (!hasSkip) {
      // 如果已经跳过，本次登录态内不再判断
      this.checkExportRefundOpened()
    }
    this.getProducts()
  },
  // 生命周期 - 挂载完成(访问DOM元素)
  mounted() {},
  // 方法集合
  methods: {
    async getProducts() {
      const { getProductList } = this.$API.productCenter
      const enterpriseId = sessionStorage.getItem('enterpriseId')
      if (!enterpriseId) return
      const { data } = await getProductList(enterpriseId)
      if (data.code !== '200') return
      this.productsStatus = data.data
    },
    // 出口退税产品是否开通
    async checkExportRefundOpened() {
      const { isExportRefundOpened } = this.$API.productCenter
      const enterpriseId = sessionStorage.getItem('enterpriseId')
      const { data } = await isExportRefundOpened(enterpriseId)
      if (data.code !== '200' || !['EXPORT_DRAWBACK'].includes(this.$route.query.productType)) return
      if (data.data) {
        // 跳转至出口退税预填写页
        this.$router.push({
          path: '/exportDrawbackKyc',
          query: { type: 'prefill' },
        })
      }
    },
    handleUse(item) {
      console.log('menuCode', item)
      this.switchProductByMenuCode(item.menuCode)
    },
    // 申请使用
    async handleGrant() {
      this.$confirm(
          this.$t('productCenter.productActivationDes'),
          this.$t('productCenter.productActivation'),
          {
            confirmButtonText: this.$t('login.confirm'),
            showClose: false,
            showCancelButton: false,
            type: 'info',
          }
        )
    },
    // 开始认证
    async handleAuthentication(item) {
      // 资产交易平台单独处理
      if(item.productType === 'MARKET'){
        this.handleGrant()
        return
      }
      const { validateProductKyc } = this.$API.productCenter
      const enterpriseId = sessionStorage.getItem('enterpriseId')
      const productType = item.productType
      const { data } = await validateProductKyc({ enterpriseId, productType })
      if (data.code !== '200') return
      if ( !data.data) {
        this.$message.warning( this.$t('productCenter.kycStatus'))
        return
      } else {
        if (typeof item.kycRoutePath === 'function') {
          item.appRoutePath()
        } else {
          this.$router.push({ path: item.kycRoutePath,query:{productType} })
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.products {
  height: 100%;
  background: #f7fbff;
  &-wrap {

    // flex-wrap: wrap;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 2px 2px 10px 0px rgba(46, 90, 153, 0.10);
    padding: 12px 24px;
    min-height: calc(100vh - 230px);
  }
}
.products-wrap-title {
  height: 32px;
  color: #2e5a99;
  font-size: 20px;
  font-family: 'Open Sans', PingFang SC-600;
  font-weight: 600;
  text-align: LEFT;
  color: #2e5a99;
  line-height: 32px;
  margin-bottom: 12px;
}
.products-item {
  flex: 1;
  height: 170px;
  // overflow: hidden;
  // display: flex;
  // font-family: PingFangSC, Open Sans;
  height: 170px;
  background: #f7fbff;
  border-radius: 8px;
  box-shadow: 0px 3px 7.2px 0px rgba(148,185,223,0.26); 
  flex: 0 0 calc(33.333% - 40px / 3);

  &-left {
    // width: 380px;
    // padding: 32px;
    display: flex;
    flex-direction: column;
    height: 114px;
    background: #ffffff;
    border-radius: 8px;
    overflow: hidden;
    padding: 6px 14px;
    position: relative;
    .products-item-left_title {
      display: flex;
      // justify-content: space-between;
      align-items: center;
      margin-bottom: 5px;
      gap: 5px;

      .title_name {
        font-weight: 600;
        font-size: 16px;
        color: #2e5a99;
        line-height: 20px;
        margin-right: 4px;
      }
    }
    .products-item-left_tip {
      background: #ffffff;
      border-radius: 8px;
      border: 0.5px solid #ff9326;
      border-radius: 4px;
      font-size: 12px;
      text-align: CENTER;
      color: #ff9326;
      line-height: 18px;
      padding: 0 6px;

    }
    .products-item-left_des {
      // flex: 1;
      font-weight: 400;
      font-size: 12px;
      color: #89929e;
      line-height: 18px;
      text-align: left;
      white-space: pre-line;
      padding: 0 5px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
      text-overflow: ellipsis;
      height: 54px;
    }
    .products-item-left_btn {
      display: flex;
      justify-content: space-between;
    }
    
  }
  &-right {
    width: 320px;
    height: 280px;
  }
}
.subscribe-now-wrapper {
  position: relative;
  .qrcode-wrapper {
    position: absolute;
    bottom: 40px;
    right: 0;
    width: 272px;
    padding: 0 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #ffffff;
    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.3);
  }
  img {
  }
  .qrcode-tip {
    // width: 100%;
    text-wrap: wrap;
    text-align: center;
  }
}
.products-banner {
  height: 120px;
  width: 100%;
  // background: url("~@/static/projectImg/login/banner.png") no-repeat;
  background-size: cover;
  border-radius: 8px;
  background: linear-gradient(90deg, #a0cbff, #f7f9ff 100%);
  // padding: 25px 0 0 24px;
  margin-bottom: 20px;
  position: relative;
  overflow: hidden;
  .products-banner-img{
    height: 100%;
    // width: 550px
    float: right;
  }
  .banner-text {
    width: 517px;
    height: 120px;
    clip-path: inset(0 100px 0 0);
  }
  .banner-title {
    font-size: 40px;
    font-weight: 400;
    text-align: LEFT;
    color: #ffffff;
    line-height: 48px;
    // text-shadow: 0px 4px 4px 0px rgba(154,199,255,0.60), 0px 2px 2px 0px #5ca5ff;
    text-shadow: 0px 2px 2px #5ca5ff;
    margin-bottom: 8px;
  }
  .info-text {
    height: 16px;
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
    line-height: 16px;
  }
}
.products-item-left_btn {
  display: flex;
  margin: 12px 20px;
  gap: 8px;
}
.products-item-left_title-icon {
  width: 36px;
  height: 32px;
  background: url("~@/static/projectImg/login/exportDrawback.png") no-repeat;
  background-size: cover;
  flex: 0 0 36px;
}
.icon1 {
  background: url("~@/static/projectImg/login/digitalPayment.png") no-repeat;
  background-size: cover;
}
.icon2 {
  background: url("~@/static/projectImg/login/digitalFinance.png") no-repeat;
  background-size: cover;
}
.slanting-banner {
  width: 86px;
  height: 21px;
  line-height: 22px;
  background: linear-gradient(41deg, #0acc8b 0%, #c6f5e5 100%);
  color: #fff;
  transform: rotate(45deg);
  position: absolute;
  text-align: center;
  right: -25px;
  font-size: 12px;
  top: 8px;
  font-size: 12px;
}
.ACTIVATED {
  background: linear-gradient(41deg, #0acc8b 0%, #c6f5e5 100%);
}
.NOT_APPROVED,.FAILED {
  background: linear-gradient(41deg,#ff4040 0%, #ffb2b2 100%)
}
.UNDER_REVIEW {
  background: linear-gradient(40deg,#3b8cfa 0%, #b2d2ff 100%);
}
// ::v-deep .lls-button--primary {
//   background: linear-gradient(43deg,#3b8cfa 0%, #b2d2ff 100%);
//   font-weight: 500;
// }
// .lls-button--primary
</style>
